import serverCall from "../serverCall";

const CreateFacility = (data) => {
  return serverCall.post(`${process.env.REACT_APP_BASE_API_URL}/facility/admin/create`, data);;
};

const GetFacilitySingleId = async (id) => {
  try {
    const response = await serverCall.get(`/facility/admin/get/${id}`);
    return response;
  } catch (error) {
    console.log("FacilitySingleId Api error", error);
  }
};

const UpdateFacilityDataRequest = async (id, body) => {
  try {
    const response = await serverCall.put(`/facility/admin/update/${id}`, body);
    return response;
  } catch (error) {
    console.log("GetFaqSingleId Api error", error);
  }
};

const DeleteFacilityDataRequest = (id) => {
  return serverCall.delete(`/facility/admin/delete/${id}`);
};

const GetFacilityGameSingleId = async (id, formatedDate) => {
  try {
    const response = await serverCall.get(
      `/facility/admin/games/${id}/${formatedDate}`
    );
    console.log("hrsd formatedDate", formatedDate);
    return response;
  } catch (error) {
    console.log("FacilitySingleId Api error", error);
  }
};

const FacilityData = {
  CreateFacility,
  GetFacilitySingleId,
  UpdateFacilityDataRequest,
  DeleteFacilityDataRequest,
  GetFacilityGameSingleId,
};

export default FacilityData;
